module.exports = __webpack_public_path__ + "media/images/classpoints/classpoints-hero_clubpilates-fba3610c7dd9a2e02927ba7b2349bb82.png";